import W from "../../phone-codes/phone-codes.js";
import { c as B, f as G, p as b, F as H, a as V, V as d, e as Y, b as F, s as X, d as q, g as p, P as J, M as w, i as z, h as K, j as Q, k as Z, m as tt } from "../../../getCountryByCallingCode-D_emPjr3.js";
function et(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function nt(e, n) {
  for (var t = 0; t < n.length; t++) {
    var a = n[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function at(e, n, t) {
  return n && nt(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var rt = /* @__PURE__ */ function() {
  function e(n) {
    var t = n.onCountryChange, a = n.onCallingCodeChange;
    et(this, e), this.onCountryChange = t, this.onCallingCodeChange = a;
  }
  return at(e, [{
    key: "reset",
    value: function(t) {
      var a = t.country, r = t.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(a, r);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(t) {
      for (var a = 0, r = Object.keys(t); a < r.length; a++) {
        var i = r[a];
        this[i] = t[i];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(t, a) {
      this.setCountry(t), this.setCallingCode(a);
    }
  }, {
    key: "setCountry",
    value: function(t) {
      this.country = t, this.onCountryChange(t);
    }
  }, {
    key: "setCallingCode",
    value: function(t) {
      this.callingCode = t, this.onCallingCodeChange(t, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(t, a) {
      this.international = !0, this.initCountryAndCallingCode(t, a);
    }
  }, {
    key: "appendDigits",
    value: function(t) {
      this.digits += t;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(t) {
      this.nationalSignificantNumber += t;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), e;
}();
function it(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = ot(e)) || n) {
    t && (e = t);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ot(e, n) {
  if (e) {
    if (typeof e == "string") return I(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return I(e, n);
  }
}
function I(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
var h = "x", x = new RegExp(h);
function v(e, n) {
  if (n < 1)
    return "";
  for (var t = ""; n > 1; )
    n & 1 && (t += e), n >>= 1, e += e;
  return t + e;
}
function E(e, n) {
  return e[n] === ")" && n++, ut(e.slice(0, n));
}
function ut(e) {
  for (var n = [], t = 0; t < e.length; )
    e[t] === "(" ? n.push(t) : e[t] === ")" && n.pop(), t++;
  var a = 0, r = "";
  n.push(e.length);
  for (var i = 0, o = n; i < o.length; i++) {
    var u = o[i];
    r += e.slice(a, u), a = u + 1;
  }
  return r;
}
function lt(e, n, t) {
  for (var a = it(t.split("")), r; !(r = a()).done; ) {
    var i = r.value;
    if (e.slice(n + 1).search(x) < 0)
      return;
    n = e.search(x), e = e.replace(x, i);
  }
  return [e, n];
}
function st(e, n, t) {
  var a = t.metadata, r = t.shouldTryNationalPrefixFormattingRule, i = t.getSeparatorAfterNationalPrefix, o = new RegExp("^(?:".concat(n.pattern(), ")$"));
  if (o.test(e.nationalSignificantNumber))
    return ct(e, n, {
      metadata: a,
      shouldTryNationalPrefixFormattingRule: r,
      getSeparatorAfterNationalPrefix: i
    });
}
function ft(e, n) {
  return B(e, n) === "IS_POSSIBLE";
}
function ct(e, n, t) {
  var a = t.metadata, r = t.shouldTryNationalPrefixFormattingRule, i = t.getSeparatorAfterNationalPrefix;
  if (e.nationalSignificantNumber, e.international, e.nationalPrefix, e.carrierCode, r(n)) {
    var o = k(e, n, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: i,
      metadata: a
    });
    if (o)
      return o;
  }
  return k(e, n, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: i,
    metadata: a
  });
}
function k(e, n, t) {
  var a = t.metadata, r = t.useNationalPrefixFormattingRule, i = t.getSeparatorAfterNationalPrefix, o = G(e.nationalSignificantNumber, n, {
    carrierCode: e.carrierCode,
    useInternationalFormat: e.international,
    withNationalPrefix: r,
    metadata: a
  });
  if (r || (e.nationalPrefix ? o = e.nationalPrefix + i(n) + o : e.complexPrefixBeforeNationalSignificantNumber && (o = e.complexPrefixBeforeNationalSignificantNumber + " " + o)), ht(o, e))
    return o;
}
function ht(e, n) {
  return b(e) === n.getNationalDigits();
}
function gt(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function mt(e, n) {
  for (var t = 0; t < n.length; t++) {
    var a = n[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function dt(e, n, t) {
  return n && mt(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Nt = /* @__PURE__ */ function() {
  function e() {
    gt(this, e);
  }
  return dt(e, [{
    key: "parse",
    value: function(t) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(t), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var a = this.context[0], r = a.branches, i = a.instructions;
      if (r)
        return {
          op: "|",
          args: r.concat([A(i)])
        };
      if (i.length === 0)
        throw new Error("Pattern is required");
      return i.length === 1 ? i[0] : i;
    }
  }, {
    key: "startContext",
    value: function(t) {
      this.context.push(t);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(t) {
      if (!t)
        throw new Error("Pattern is required");
      var a = t.match(vt);
      if (!a) {
        if (Ct.test(t))
          throw new Error("Illegal characters found in a pattern: ".concat(t));
        this.getContext().instructions = this.getContext().instructions.concat(t.split(""));
        return;
      }
      var r = a[1], i = t.slice(0, a.index), o = t.slice(a.index + r.length);
      switch (r) {
        case "(?:":
          i && this.parsePattern(i), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (i && this.parsePattern(i), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var u = this.getContext(), l = u.branches;
          l.push(A(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: l
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (i && this.parsePattern(i), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(A(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          i && this.parsePattern(i), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: yt(i)
          });
          break;
        /* istanbul ignore next */
        default:
          throw new Error("Unknown operator: ".concat(r));
      }
      o && this.parsePattern(o);
    }
  }]), e;
}();
function yt(e) {
  for (var n = [], t = 0; t < e.length; ) {
    if (e[t] === "-") {
      if (t === 0 || t === e.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(e));
      for (var a = e[t - 1].charCodeAt(0) + 1, r = e[t + 1].charCodeAt(0) - 1, i = a; i <= r; )
        n.push(String.fromCharCode(i)), i++;
    } else
      n.push(e[t]);
    t++;
  }
  return n;
}
var Ct = /[\(\)\[\]\?\:\|]/, vt = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function A(e) {
  return e.length === 1 ? e[0] : e;
}
function _(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = bt(e)) || n) {
    t && (e = t);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bt(e, n) {
  if (e) {
    if (typeof e == "string") return D(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return D(e, n);
  }
}
function D(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function pt(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Pt(e, n) {
  for (var t = 0; t < n.length; t++) {
    var a = n[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function xt(e, n, t) {
  return n && Pt(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var At = /* @__PURE__ */ function() {
  function e(n) {
    pt(this, e), this.matchTree = new Nt().parse(n);
  }
  return xt(e, [{
    key: "match",
    value: function(t) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = a.allowOverflow;
      if (!t)
        throw new Error("String is required");
      var i = S(t.split(""), this.matchTree, !0);
      if (i && i.match && delete i.matchedChars, !(i && i.overflow && !r))
        return i;
    }
  }]), e;
}();
function S(e, n, t) {
  if (typeof n == "string") {
    var a = e.join("");
    return n.indexOf(a) === 0 ? e.length === n.length ? {
      match: !0,
      matchedChars: e
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : a.indexOf(n) === 0 ? t && e.length > n.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, n.length)
    } : void 0;
  }
  if (Array.isArray(n)) {
    for (var r = e.slice(), i = 0; i < n.length; ) {
      var o = n[i], u = S(r, o, t && i === n.length - 1);
      if (u) {
        if (u.overflow)
          return u;
        if (u.match) {
          if (r = r.slice(u.matchedChars.length), r.length === 0)
            return i === n.length - 1 ? {
              match: !0,
              matchedChars: e
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (u.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(u, null, 2)));
        }
      } else return;
      i++;
    }
    return t ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, e.length - r.length)
    };
  }
  switch (n.op) {
    case "|":
      for (var l, s = _(n.args), f; !(f = s()).done; ) {
        var g = f.value, c = S(e, g, t);
        if (c) {
          if (c.overflow)
            return c;
          if (c.match)
            return {
              match: !0,
              matchedChars: c.matchedChars
            };
          if (c.partialMatch)
            l = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(c, null, 2)));
        }
      }
      return l ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var y = _(n.args), C; !(C = y()).done; ) {
        var N = C.value;
        if (e[0] === N)
          return e.length === 1 ? {
            match: !0,
            matchedChars: e
          } : t ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [N]
          };
      }
      return;
    /* istanbul ignore next */
    default:
      throw new Error("Unsupported instruction tree: ".concat(n));
  }
}
function R(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = St(e)) || n) {
    t && (e = t);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function St(e, n) {
  if (e) {
    if (typeof e == "string") return O(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return O(e, n);
  }
}
function O(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function Tt(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Ft(e, n) {
  for (var t = 0; t < n.length; t++) {
    var a = n[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function wt(e, n, t) {
  return n && Ft(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var T = "9", It = 15, Et = v(T, It), kt = /[- ]/, _t = function() {
  return /\[([^\[\]])*\]/g;
}, Dt = function() {
  return /\d(?=[^,}][^,}])/g;
}, Rt = new RegExp("[" + d + "]*\\$1[" + d + "]*(\\$\\d[" + d + "]*)*$"), $ = 3, Ot = /* @__PURE__ */ function() {
  function e(n) {
    n.state;
    var t = n.metadata;
    Tt(this, e), this.metadata = t, this.resetFormat();
  }
  return wt(e, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(t, a) {
      this.resetFormat(), t ? (this.isNANP = t.callingCode() === "1", this.matchingFormats = t.formats(), a.nationalSignificantNumber && this.narrowDownMatchingFormats(a)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(t, a) {
      var r = this;
      if (ft(a.nationalSignificantNumber, this.metadata))
        for (var i = R(this.matchingFormats), o; !(o = i()).done; ) {
          var u = o.value, l = st(a, u, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(f) {
              return r.shouldTryNationalPrefixFormattingRule(f, {
                international: a.international,
                nationalPrefix: a.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(f) {
              return r.getSeparatorAfterNationalPrefix(f);
            }
          });
          if (l)
            return this.resetFormat(), this.chosenFormat = u, this.setNationalNumberTemplate(l.replace(/\d/g, h), a), this.populatedNationalNumberTemplate = l, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(h), l;
        }
      return this.formatNationalNumberWithNextDigits(t, a);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(t, a) {
      var r = this.chosenFormat, i = this.chooseFormat(a);
      if (i)
        return i === r ? this.formatNextNationalNumberDigits(t) : this.formatNextNationalNumberDigits(a.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(t) {
      var a = this, r = t.nationalSignificantNumber, i = t.nationalPrefix, o = t.international, u = r, l = u.length - $;
      l < 0 && (l = 0), this.matchingFormats = this.matchingFormats.filter(function(s) {
        return a.formatSuits(s, o, i) && a.formatMatches(s, u, l);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(t, a, r) {
      return !(r && !t.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !t.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !a && !r && t.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(t, a, r) {
      var i = t.leadingDigitsPatterns().length;
      if (i === 0)
        return !0;
      r = Math.min(r, i - 1);
      var o = t.leadingDigitsPatterns()[r];
      if (a.length < $)
        try {
          return new At(o).match(a, {
            allowOverflow: !0
          }) !== void 0;
        } catch (u) {
          return console.error(u), !0;
        }
      return new RegExp("^(".concat(o, ")")).test(a);
    }
  }, {
    key: "getFormatFormat",
    value: function(t, a) {
      return a ? t.internationalFormat() : t.format();
    }
  }, {
    key: "chooseFormat",
    value: function(t) {
      for (var a = this, r = function() {
        var s = o.value;
        return a.chosenFormat === s ? "break" : Rt.test(a.getFormatFormat(s, t.international)) ? a.createTemplateForFormat(s, t) ? (a.chosenFormat = s, "break") : (a.matchingFormats = a.matchingFormats.filter(function(f) {
          return f !== s;
        }), "continue") : "continue";
      }, i = R(this.matchingFormats.slice()), o; !(o = i()).done; ) {
        var u = r();
        if (u === "break") break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(t, a) {
      if (!(t.pattern().indexOf("|") >= 0)) {
        var r = this.getTemplateForFormat(t, a);
        if (r)
          return this.setNationalNumberTemplate(r, a), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(t) {
      return this.isNANP || t && t.nationalPrefixFormattingRule() && kt.test(t.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(t, a) {
      var r = t.IDDPrefix, i = t.missingPlus;
      return r ? a && a.spacing === !1 ? r : r + " " : i ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(t) {
      if (this.template) {
        for (var a = -1, r = 0, i = t.international ? this.getInternationalPrefixBeforeCountryCallingCode(t, {
          spacing: !1
        }) : ""; r < i.length + t.getDigitsWithoutInternationalPrefix().length; )
          a = this.template.indexOf(h, a + 1), r++;
        return E(this.template, a + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(t, a) {
      this.nationalNumberTemplate = t, this.populatedNationalNumberTemplate = t, this.populatedNationalNumberTemplatePosition = -1, a.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(a).replace(/[\d\+]/g, h) + v(h, a.callingCode.length) + " " + t : this.template = t;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(t, a) {
      var r = a.nationalSignificantNumber, i = a.international, o = a.nationalPrefix, u = a.complexPrefixBeforeNationalSignificantNumber, l = t.pattern();
      l = l.replace(_t(), "\\d").replace(Dt(), "\\d");
      var s = Et.match(l)[0];
      if (!(r.length > s.length)) {
        var f = new RegExp("^" + l + "$"), g = r.replace(/\d/g, T);
        f.test(g) && (s = g);
        var c = this.getFormatFormat(t, i), y;
        if (this.shouldTryNationalPrefixFormattingRule(t, {
          international: i,
          nationalPrefix: o
        })) {
          var C = c.replace(H, t.nationalPrefixFormattingRule());
          if (b(t.nationalPrefixFormattingRule()) === (o || "") + b("$1") && (c = C, y = !0, o))
            for (var N = o.length; N > 0; )
              c = c.replace(/\d/, h), N--;
        }
        var m = s.replace(new RegExp(l), c).replace(new RegExp(T, "g"), h);
        return y || (u ? m = v(h, u.length) + " " + m : o && (m = v(h, o.length) + this.getSeparatorAfterNationalPrefix(t) + m)), i && (m = V(m)), m;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(t) {
      var a = lt(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, t);
      if (!a) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = a[0], this.populatedNationalNumberTemplatePosition = a[1], E(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(t, a) {
      var r = a.international, i = a.nationalPrefix;
      if (t.nationalPrefixFormattingRule()) {
        var o = t.usesNationalPrefix();
        if (o && i || !o && !r)
          return !0;
      }
    }
  }]), e;
}();
function j(e, n) {
  return jt(e) || Lt(e, n) || Mt(e, n) || $t();
}
function $t() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Mt(e, n) {
  if (e) {
    if (typeof e == "string") return M(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return M(e, n);
  }
}
function M(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function Lt(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var a = [], r = !0, i = !1, o, u;
    try {
      for (t = t.call(e); !(r = (o = t.next()).done) && (a.push(o.value), !(n && a.length === n)); r = !0)
        ;
    } catch (l) {
      i = !0, u = l;
    } finally {
      try {
        !r && t.return != null && t.return();
      } finally {
        if (i) throw u;
      }
    }
    return a;
  }
}
function jt(e) {
  if (Array.isArray(e)) return e;
}
function Ut(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Wt(e, n) {
  for (var t = 0; t < n.length; t++) {
    var a = n[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function Bt(e, n, t) {
  return n && Wt(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Gt = "[" + d + p + "]+", Ht = new RegExp("^" + Gt + "$", "i"), Vt = "(?:[" + J + "][" + d + p + "]*|[" + d + p + "]+)", Yt = new RegExp("[^" + d + p + "]+.*$"), Xt = /[^\d\[\]]/, qt = /* @__PURE__ */ function() {
  function e(n) {
    var t = n.defaultCountry, a = n.defaultCallingCode, r = n.metadata, i = n.onNationalSignificantNumberChange;
    Ut(this, e), this.defaultCountry = t, this.defaultCallingCode = a, this.metadata = r, this.onNationalSignificantNumberChange = i;
  }
  return Bt(e, [{
    key: "input",
    value: function(t, a) {
      var r = Kt(t), i = j(r, 2), o = i[0], u = i[1], l = b(o), s;
      return u && (a.digits || (a.startInternationalNumber(), l || (s = !0))), l && this.inputDigits(l, a), {
        digits: l,
        justLeadingPlus: s
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(t, a) {
      var r = a.digits, i = r.length < 3 && r.length + t.length >= 3;
      if (a.appendDigits(t), i && this.extractIddPrefix(a), this.isWaitingForCountryCallingCode(a)) {
        if (!this.extractCountryCallingCode(a))
          return;
      } else
        a.appendNationalSignificantNumberDigits(t);
      a.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(a.getNationalDigits(), function(o) {
        return a.update(o);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(t) {
      var a = t.international, r = t.callingCode;
      return a && !r;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(t) {
      var a = Y("+" + t.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), r = a.countryCallingCode, i = a.number;
      if (r)
        return t.setCallingCode(r), t.update({
          nationalSignificantNumber: i
        }), !0;
    }
  }, {
    key: "reset",
    value: function(t) {
      if (t) {
        this.hasSelectedNumberingPlan = !0;
        var a = t._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = a && Xt.test(a);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(t, a) {
      if (this.hasSelectedNumberingPlan) {
        var r = F(t, this.metadata), i = r.nationalPrefix, o = r.nationalNumber, u = r.carrierCode;
        if (o !== t)
          return this.onExtractedNationalNumber(i, u, o, t, a), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(t, a, r) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(t, r);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var i = F(t, this.metadata), o = i.nationalPrefix, u = i.nationalNumber, l = i.carrierCode;
        if (u !== a)
          return this.onExtractedNationalNumber(o, l, u, t, r), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(t, a, r, i, o) {
      var u, l, s = i.lastIndexOf(r);
      if (s >= 0 && s === i.length - r.length) {
        l = !0;
        var f = i.slice(0, s);
        f !== t && (u = f);
      }
      o({
        nationalPrefix: t,
        carrierCode: a,
        nationalSignificantNumber: r,
        nationalSignificantNumberMatchesInput: l,
        complexPrefixBeforeNationalSignificantNumber: u
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(t) {
      if (this.extractAnotherNationalSignificantNumber(t.getNationalDigits(), t.nationalSignificantNumber, function(a) {
        return t.update(a);
      }))
        return !0;
      if (this.extractIddPrefix(t))
        return this.extractCallingCodeAndNationalSignificantNumber(t), !0;
      if (this.fixMissingPlus(t))
        return this.extractCallingCodeAndNationalSignificantNumber(t), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(t) {
      var a = t.international, r = t.IDDPrefix, i = t.digits;
      if (t.nationalSignificantNumber, !(a || r)) {
        var o = X(i, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (o !== void 0 && o !== i)
          return t.update({
            IDDPrefix: i.slice(0, i.length - o.length)
          }), this.startInternationalNumber(t, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(t) {
      if (!t.international) {
        var a = q(t.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), r = a.countryCallingCode;
        if (a.number, r)
          return t.update({
            missingPlus: !0
          }), this.startInternationalNumber(t, {
            country: t.country,
            callingCode: r
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(t, a) {
      var r = a.country, i = a.callingCode;
      t.startInternationalNumber(r, i), t.nationalSignificantNumber && (t.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(t) {
      this.extractCountryCallingCode(t) && this.extractNationalSignificantNumber(t.getNationalDigits(), function(a) {
        return t.update(a);
      });
    }
  }]), e;
}();
function Jt(e) {
  var n = e.search(Vt);
  if (!(n < 0)) {
    e = e.slice(n);
    var t;
    return e[0] === "+" && (t = !0, e = e.slice(1)), e = e.replace(Yt, ""), t && (e = "+" + e), e;
  }
}
function zt(e) {
  var n = Jt(e) || "";
  return n[0] === "+" ? [n.slice(1), !0] : [n];
}
function Kt(e) {
  var n = zt(e), t = j(n, 2), a = t[0], r = t[1];
  return Ht.test(a) || (a = ""), [a, r];
}
function Qt(e, n) {
  return ne(e) || ee(e, n) || te(e, n) || Zt();
}
function Zt() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function te(e, n) {
  if (e) {
    if (typeof e == "string") return L(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return L(e, n);
  }
}
function L(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function ee(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var a = [], r = !0, i = !1, o, u;
    try {
      for (t = t.call(e); !(r = (o = t.next()).done) && (a.push(o.value), !(n && a.length === n)); r = !0)
        ;
    } catch (l) {
      i = !0, u = l;
    } finally {
      try {
        !r && t.return != null && t.return();
      } finally {
        if (i) throw u;
      }
    }
    return a;
  }
}
function ne(e) {
  if (Array.isArray(e)) return e;
}
function ae(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function re(e, n) {
  for (var t = 0; t < n.length; t++) {
    var a = n[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function ie(e, n, t) {
  return n && re(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var U = /* @__PURE__ */ function() {
  function e(n, t) {
    ae(this, e), this.metadata = new w(t);
    var a = this.getCountryAndCallingCode(n), r = Qt(a, 2), i = r[0], o = r[1];
    this.defaultCountry = i, this.defaultCallingCode = o, this.reset();
  }
  return ie(e, [{
    key: "getCountryAndCallingCode",
    value: function(t) {
      var a, r;
      return t && (z(t) ? (a = t.defaultCountry, r = t.defaultCallingCode) : a = t), a && !this.metadata.hasCountry(a) && (a = void 0), [a, r];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(t) {
      var a = this.parser.input(t, this.state), r = a.digits, i = a.justLeadingPlus;
      if (i)
        this.formattedOutput = "+";
      else if (r) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var o;
        if (this.metadata.hasSelectedNumberingPlan() && (o = this.formatter.format(r, this.state)), o === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var u = this.state.getNationalDigits();
          u && (o = this.formatter.format(u, this.state));
        }
        this.formattedOutput = o ? this.getFullNumber(o) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var t = this;
      return this.state = new rt({
        onCountryChange: function(r) {
          t.country = r;
        },
        onCallingCodeChange: function(r, i) {
          t.metadata.selectNumberingPlan(i, r), t.formatter.reset(t.metadata.numberingPlan, t.state), t.parser.reset(t.metadata.numberingPlan);
        }
      }), this.formatter = new Ot({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new qt({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          t.determineTheCountryIfNeeded(), t.formatter.reset(t.metadata.numberingPlan, t.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var t = this.state.digits;
      if (t)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var t = this.state.country;
      return t;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(t) {
      var a = this;
      if (this.isInternational()) {
        var r = function(u) {
          return a.formatter.getInternationalPrefixBeforeCountryCallingCode(a.state, {
            spacing: !!u
          }) + u;
        }, i = this.state.callingCode;
        return r(i ? t ? "".concat(i, " ").concat(t) : i : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return t;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var t = this.state, a = t.nationalSignificantNumber, r = t.complexPrefixBeforeNationalSignificantNumber, i = t.nationalPrefix, o = a, u = r || i;
      return u && (o = u + o), o;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var t = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(t ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var t = this.getNonFormattedNumber();
      if (t)
        return t.replace(/[\+\d]/g, h);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var t = this.state.callingCode, a = this.metadata.getCountryCodesForCallingCode(t);
      return a && a.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(K(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var t = this.state, a = t.digits, r = t.callingCode, i = t.country, o = t.nationalSignificantNumber;
      if (a) {
        if (this.isInternational())
          return r ? "+" + r + o : "+" + a;
        if (i || r) {
          var u = i ? this.metadata.countryCallingCode() : r;
          return "+" + u + o;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var t = this.state, a = t.nationalSignificantNumber, r = t.carrierCode, i = t.callingCode, o = this._getCountry();
      if (a && !(!o && !i)) {
        if (o && o === this.defaultCountry) {
          var u = new w(this.metadata.metadata);
          u.selectNumberingPlan(o);
          var l = u.numberingPlan.callingCode(), s = this.metadata.getCountryCodesForCallingCode(l);
          if (s.length > 1) {
            var f = Q(a, {
              countries: s,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            f && (o = f);
          }
        }
        var g = new Z(o || i, a, this.metadata.metadata);
        return r && (g.carrierCode = r), g;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var t = this.getNumber();
      return t ? t.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var t = this.getNumber();
      return t ? t.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), e;
}();
function P(e) {
  return U.call(this, e, tt);
}
P.prototype = Object.create(U.prototype, {});
P.prototype.constructor = P;
class le {
  telephone(n, t, a = !1) {
    const r = t.toUpperCase(), i = a ? "+" + W(t) : "";
    let o = new P();
    o.defaultCountry = r, o.reset(), o.input(i + n);
    let u = o.getTemplate();
    return u = u.replaceAll("(", ""), u = u.replaceAll(")", ""), u = u.replaceAll("x", "9"), u = u.slice(i.length).trim(), u;
  }
}
export {
  le as default
};
